module.exports = require('./lib-node')



//////////////////
// WEBPACK FOOTER
// ./~/get-it/index.js
// module id = 374
// module chunks = 0